import React from 'react'
import './index.less'
import PopupBottomModal from '../popup-bottom-modal'
import { downloadImage } from '../../utils/common'
import Toast from '@xpeng/rc-toast'

interface SharePosterPanelPropsRule {
  posterUrl: string
  visible: boolean
  onClose?: () => void
}

const SharePosterPanel = (props: SharePosterPanelPropsRule) => {
  const { posterUrl, visible, onClose = () => {} } = props
  const UA = navigator.userAgent || "";
  const isIOS = /iPhone|iPad|iPod/i.test(UA);

  const saveToPhone = () => {
    Toast.show('长按图片进行保存', {
      containerStyle: {
        zIndex: 9999
      }
    })
    
    // downloadImage(posterUrl, Date.now()).then(() => {
    //   Toast.show('保存成功', {
    //     containerStyle: {
    //       zIndex: 9999
    //     }
    //   })
    //   onClose()
    // }).catch((e) => {
    //   Toast.show(e, {
    //     containerStyle: {
    //       zIndex: 9999
    //     }
    //   })
    // })
  }

  return <>
    {visible && <img src={posterUrl} alt="" className='poster' />}
    <PopupBottomModal
      visible={visible}
      title=''
      onClose={onClose}
    >
      <div className='share-poster-panel'>
        <div className='save-to-phone' onClick={saveToPhone}>
          保存到手机
        </div>
        <div className='cancel' onClick={onClose}>
          取消
        </div>
      </div>
    </PopupBottomModal>
  </>
}

export default SharePosterPanel